/// <amd-module name="SuiteCommerce.StockNotifications.Subscription.Create.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Subscription.Create.View", ["require", "exports", "underscore", "jQuery", "Backbone", "Backbone.FormView", "SuiteCommerce.StockNotifications.Configuration", "SuiteCommerce.StockNotifications.Utils", "SuiteCommerce.StockNotifications.Instrumentation", "SuiteCommerce.StockNotifications.Item.Model", "SuiteCommerce.StockNotifications.Subscription.Model", "suitecommerce_stocknotifications_subscription_create.tpl", "SuiteCommerce.StockNotifications.PDP.Model"], function (require, exports, _, jQuery, Backbone_1, Backbone_FormView_1, Configuration_1, Utils_1, Instrumentation_1, Item_Model_1, Subscription_Model_1, subscriptionCreateTpl, PDP_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SubscriptionCreateView = void 0;
    var SubscriptionCreateView = /** @class */ (function (_super) {
        __extends(SubscriptionCreateView, _super);
        function SubscriptionCreateView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = subscriptionCreateTpl;
            _this.events = {
                'submit form': 'saveTheForm',
                'click [data-action="stocknotifications-subscribeToAll"]': 'setSubscribeToAll',
                'click [data-action="stocknotifications-subscribeToMails"]': 'subscribeToMails',
            };
            _this.bindings = {
                '[name="firstname"]': 'firstname',
                '[name="lastname"]': 'lastname',
                '[name="email"]': 'email',
                '[name="subscribeToMails"]': 'subscribeToMails',
                '[name="subscribeToAll"]': 'subscribeToAll',
                '[name="matrixparent"]': 'matrixparent'
            };
            _this.title = options.title || '';
            _this.successMessage = Configuration_1.Configuration.get('stockNotifications.pdp.successMessage');
            _this.errorMessage = Configuration_1.Configuration.get('stockNotifications.pdp.errorMessage');
            _this.application = options.application;
            _this.selectedProduct = options.selectedProduct;
            _this.matrixParentId = options.matrixParentId;
            _this.selectedMatrixChild = options.selectedMatrixChild;
            _this.profileComponent = _this.getProfilePromise(options.application);
            _this.pdpModel = options.pdpModel || new PDP_Model_1.PdpModel();
            _this.pdp = options.pdp || _this.application.getComponent('PDP');
            _this.setNewModel();
            _this.profileComponent.then(function (profile) {
                _this.model.set('firstname', profile.firstname);
                _this.model.set('lastname', profile.lastname);
                _this.model.set('email', profile.email);
                _this.model.set('subscribeToAll', _this.pdpModel.isSubscribeToAll);
                _this.updateMatrixParentId();
                _this.render();
            });
            Backbone_FormView_1.add(_this);
            return _this;
        }
        SubscriptionCreateView.prototype.getProfilePromise = function (options) {
            try {
                var profileComponent = options.getComponent('UserProfile');
                if (profileComponent && _.isFunction(profileComponent.getUserProfile)) {
                    return profileComponent.getUserProfile();
                }
                else {
                    var ProfileModel = require('Profile.Model'); // eslint-disable-line global-require
                    if (ProfileModel && _.isFunction(ProfileModel.getPromise)) {
                        return ProfileModel.getPromise();
                    }
                }
            }
            catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            }
            return jQuery.Deferred().reject().promise();
        };
        SubscriptionCreateView.prototype.subscribeToMails = function (event) {
            var $checkbox = jQuery(event.currentTarget);
            this.model.subscribeToMails = $checkbox.is(":checked");
        };
        SubscriptionCreateView.prototype.setSubscribeToAll = function (event) {
            var $checkbox = jQuery(event.currentTarget);
            this.pdpModel.subscribeToAll = $checkbox.is(":checked");
            this.updateMatrixParentId();
        };
        SubscriptionCreateView.prototype.updateMatrixParentId = function () {
            var postMatrixParent = this.pdpModel.isSubscribeToAll || !!this.selectedMatrixChild;
            var matrixParentId = postMatrixParent ? this.matrixParentId : '';
            this.model.matrixParent = matrixParentId;
        };
        SubscriptionCreateView.prototype.setNewModel = function () {
            this.model = new Subscription_Model_1.SubscriptionModel();
            this.model.set('item', this.selectedProduct);
            this.model.set('subscribeToMails', true);
            this.model.set('itemsIds', this.pdpModel.itemsIds);
        };
        SubscriptionCreateView.prototype.saveTheForm = function (event) {
            var _this = this;
            var promise;
            var isChecked = this.validationModel.get('subscribeToModel');
            event.preventDefault();
            event.stopPropagation();
            this.emptyConfirmationMessage(this.$('[data-confirm-bin-message]'));
            promise = Backbone_FormView_1.saveForm.apply(this, arguments);
            return promise && promise.done(function () {
                _this.setNewModel();
                _this.render();
                _this.showMessage(_this.successMessage, 'success');
                _this.resetView(isChecked);
                _this.logSubscriptionDone();
            }).fail(function (jqXhr) {
                // eslint-disable-next-line no-param-reassign
                jqXhr.preventDefault = true;
                _this.showMessage(_this.errorMessage, 'error');
            });
        };
        SubscriptionCreateView.prototype.showMessage = function (message, type) {
            var $confirmationMessage = this.$('[data-confirm-bin-message]');
            this.setConfirmationMessageStatusClass($confirmationMessage, type);
            $confirmationMessage.text(message).show();
            this.scheduleHideConfirmationMessage($confirmationMessage);
        };
        SubscriptionCreateView.prototype.setConfirmationMessageStatusClass = function ($confirmationMessage, type) {
            var successClass = 'stocknotifications-subscribe-message-success';
            var errorClass = 'stocknotifications-subscribe-message-error';
            if (type === 'success') {
                $confirmationMessage.addClass(successClass);
                $confirmationMessage.removeClass(errorClass);
            }
        };
        SubscriptionCreateView.prototype.scheduleHideConfirmationMessage = function ($confirmationMessage) {
            var _this = this;
            if (this.messageTimeout) {
                clearTimeout(this.messageTimeout);
            }
            this.messageTimeout = setTimeout(function () {
                $confirmationMessage.fadeOut(1000, function () {
                    _this.emptyConfirmationMessage($confirmationMessage);
                });
            }, 3000);
        };
        SubscriptionCreateView.prototype.emptyConfirmationMessage = function ($confirmationMessage) {
            $confirmationMessage.hide();
            $confirmationMessage.empty();
        };
        SubscriptionCreateView.prototype.resetView = function (isChecked) {
            this.$('form').get(0).reset();
            this.$('[name=subscribeToMails]').prop('checked', isChecked);
        };
        SubscriptionCreateView.prototype.getLogoUrl = function () {
            var logoUrl = Configuration_1.Configuration.get('header.logoUrl');
            if (logoUrl) {
                return Utils_1.Utils.getAbsoluteUrlOfNonManagedResources(logoUrl);
            }
            return Utils_1.Utils.getThemeAbsoluteUrlOfNonManagedResources('img/SC_Logo.png');
        };
        SubscriptionCreateView.prototype.getItemThumbnailUrl = function () {
            if (this.pdp) {
                var item = this.getSelectedItem();
                var thumbnailUrl = item.thumbnail;
                return thumbnailUrl && thumbnailUrl.url;
            }
            return null;
        };
        SubscriptionCreateView.prototype.getSelectedItem = function () {
            if (!this.selectedItem) {
                var selectedMatrixChild = this.pdp.getSelectedMatrixChilds();
                if (selectedMatrixChild && selectedMatrixChild.length === 1) {
                    this.selectedItem = new Item_Model_1.ItemModel(selectedMatrixChild[0]);
                    this.selectedItem.parentItem = new Item_Model_1.ItemModel(this.pdp.getItemInfo().item);
                }
                else {
                    this.selectedItem = new Item_Model_1.ItemModel(this.pdp.getItemInfo().item);
                }
            }
            return this.selectedItem;
        };
        SubscriptionCreateView.prototype.getSubscriptionDataHelper = function () {
            return {
                logoUrl: this.getLogoUrl(),
                itemThumbnailUrl: this.getItemThumbnailUrl()
            };
        };
        SubscriptionCreateView.prototype.logSubscriptionDone = function () {
            var log = Instrumentation_1.default.getLog('usage');
            log.setParameters({
                activity: 'Subscription done',
                clientContextURL: 'product/' + this.selectedProduct
            });
            log.submit();
        };
        SubscriptionCreateView.prototype.getContext = function () {
            var showMatrixParentId = !!this.selectedMatrixChild || !!this.pdpModel.isSubscribeToAll;
            var showSubscribeToAll = !!Configuration_1.Configuration.get('stockNotifications.pdp.allowSubscribingToMatrixOptionsItems') && this.pdpModel.isMatrixItem;
            return {
                selectedProduct: this.selectedProduct,
                matrixParentId: showMatrixParentId ? this.matrixParentId : '',
                subscriptionDataHelper: JSON.stringify(this.getSubscriptionDataHelper()),
                sectionTitle: Configuration_1.Configuration.get('stockNotifications.pdp.sectionTitle'),
                sectionText: Configuration_1.Configuration.get('stockNotifications.pdp.sectionText'),
                emailLabel: Configuration_1.Configuration.get('stockNotifications.pdp.emailLabel'),
                emailPlaceholder: Configuration_1.Configuration.get('stockNotifications.pdp.emailPlaceholder'),
                nameLabel: Configuration_1.Configuration.get('stockNotifications.pdp.nameLabel'),
                namePlaceholder: Configuration_1.Configuration.get('stockNotifications.pdp.namePlaceholder'),
                lastNameLabel: Configuration_1.Configuration.get('stockNotifications.pdp.lastNameLabel'),
                lastNamePlaceholder: Configuration_1.Configuration.get('stockNotifications.pdp.lastNamePlaceholder'),
                agreementLabel: Configuration_1.Configuration.get('stockNotifications.pdp.agreementLabel'),
                buttonText: Configuration_1.Configuration.get('stockNotifications.pdp.buttonText'),
                mandatoryName: Configuration_1.Configuration.get('stockNotifications.pdp.mandatoryName'),
                mandatoryLastName: Configuration_1.Configuration.get('stockNotifications.pdp.mandatoryLastName'),
                firstname: this.model.get('firstname'),
                lastname: this.model.get('lastname'),
                email: this.model.get('email'),
                suscribeToMails: this.model.get('suscribeToMails'),
                showSubscribeToAll: showSubscribeToAll,
                subscribeToAllLabel: Configuration_1.Configuration.get('stockNotifications.pdp.subscribeToMatrixLabelItems'),
                subscribeToAll: this.pdpModel.isSubscribeToAll
            };
        };
        return SubscriptionCreateView;
    }(Backbone_1.View));
    exports.SubscriptionCreateView = SubscriptionCreateView;
});
